export type ItemType = "yes_no" | "text" | "number" | "photo" | "dropdown" | "field_lookup";

export interface FieldMapping {
  id: string;
  is_active: boolean;
  datapoint: {
    id: string;
    display_name: string;
    field_name: string;
    measurement_name: string;
    bucket_name: string;
    unit: { symbol: string } | null;
  };
}

export interface ChecklistItem {
  id: string;
  item_type: ItemType;
  label: string;
  description: string | null;
  is_required: boolean;
  is_inspection: boolean;
  dropdown_options: string[] | null;
  sort_order: number;
  label_translations: Record<string, string> | null;
  description_translations: Record<string, string> | null;
  area_id: string | null;
  line_id: string | null;
  station_id: string | null;
  field_mapping_id: string | null;
  field_mappings: Array<{
    field_mapping_id: string;
    display_order: number;
  }>;
}

export interface ChecklistInfo {
  id: string;
  tenant_id: string;
  name: string;
  description: string | null;
  factory_id: string;
  area_id: string | null;
  line_id: string | null;
  station_id: string | null;
}

export interface AssignmentOption {
  value: string;
  label: string;
  indent?: number;
}

export type ChecklistLevel = "factory" | "area" | "line" | "station";

export function getChecklistLevel(checklist: ChecklistInfo): ChecklistLevel {
  if (checklist.station_id) return "station";
  if (checklist.line_id) return "line";
  if (checklist.area_id) return "area";
  return "factory";
}

export function parseAssignment(assignment: string): {
  area_id: string | null;
  line_id: string | null;
  station_id: string | null;
} {
  if (assignment === "none") return { area_id: null, line_id: null, station_id: null };
  const [type, id] = assignment.split(":");
  if (type === "area") return { area_id: id, line_id: null, station_id: null };
  if (type === "line") return { area_id: null, line_id: id, station_id: null };
  if (type === "station") return { area_id: null, line_id: null, station_id: id };
  return { area_id: null, line_id: null, station_id: null };
}

export function buildAssignment(item: ChecklistItem): string {
  if (item.station_id) return `station:${item.station_id}`;
  if (item.line_id) return `line:${item.line_id}`;
  if (item.area_id) return `area:${item.area_id}`;
  return "none";
}
